import { motion } from "framer-motion";

export const SectionHead = ({ kicker, title, sub, center = false, light = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className={`${center ? "mx-auto text-center" : ""} max-w-2xl`}
  >
    <span
      className={`inline-block rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] ${
        light ? "bg-white/10 text-sun-light" : "bg-pine-light text-pine"
      }`}
    >
      {kicker}
    </span>
    <h2 className={`mt-4 font-display text-3xl font-bold tracking-tight sm:text-5xl ${light ? "text-cream" : "text-ink"}`}>
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 text-base leading-relaxed sm:text-lg ${light ? "text-cream/75" : "text-inksoft"}`}>{sub}</p>
    )}
  </motion.div>
);
